// Copyright (c) Docugami, Inc. All rights reserved.

export enum MouseButton {
    Left = 0,
    Middle = 1,
    Right = 2
}
